import {getCurrentTimestamp} from "../../util/calendar";

export default function (description, employeeID) {
    this.timestamp = getCurrentTimestamp();
    this.description = description;
    this.employeeID = employeeID;
};